import React from 'react';
import { createRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';
import { fileNameSafeString } from '../../lib/utils/fileNameSafeString';
import { ReportName, RecordingPanelState } from './RecordingPanelState';
import { observer } from 'mobx-react-lite';
import { ChronologicalSearchResultsView } from './ChronologicalSearchResultsView';
import { SearchReportBySearchTermView } from './Reports/SearchReportBySearchTermView';
import { DataRecipientsReportView } from './Reports/DataRecipientsReportView';
import { downloadBlob } from './downloadBlob';
import { TrackingCodeReportView } from './Reports/TrackingCodeReportView';
import { IpReportView } from './Reports/IpReportView';
import { AnalyticsReportFromDatabaseView } from './Reports/AnalyticsTrafficView';

const html = String.raw;

export const ReportDownloadRouterView = observer(({ recordingPanelState }: { recordingPanelState: RecordingPanelState; }) => {
	const {recording, requestGetter, callStackResolution, getsDbEventsByIndex, eventsTableAnalysisResults, searchResultsObserver, causationGraphObserver} = recordingPanelState;
	if (recording == null) return null;
	const {startTimeIso} = recording;
	const licensePermissions = recordingPanelState.licenseCache;
	const commonArgs = { licensePermissions, callStackResolution, getsDbEventsByIndex, requestGetter } as const;
	switch (recordingPanelState.primaryTabId) {
		case 'Chronological':
			return <ChronologicalSearchResultsView {...{startTimeIso, ...commonArgs}} chronologicalResultsObserver={recordingPanelState.filteredChronologicalResultsObserver} />;
		case 'Search':
			return <SearchReportBySearchTermView {...{...commonArgs, searchResultsObserver, causationGraphObserver}} />;
		case 'IP':
			return <IpReportView {...{...commonArgs, causationGraphObserver, searchResultsObserver}} ipAddress={recordingPanelState.recording?.externallyVisibleIpAddress ?? ''}  />;
		case 'DataRecipients':
			return <DataRecipientsReportView {...{...commonArgs, ...eventsTableAnalysisResults}} />;
		case 'TrackingCode':
			return <TrackingCodeReportView {...{...commonArgs, ...eventsTableAnalysisResults}} />;
		case 'Analytics':
			return <AnalyticsReportFromDatabaseView {...{recordingUuid: recordingPanelState.recordingUuid, licensePermissions}} />;
		default: return null;
	}
});

export const downloadReport = (recordingPanelState: RecordingPanelState) => {
	const div = document.createElement('div');
	const root = createRoot(div);
			// const requestIdEventsPairs = [...log.events.reduce( (acc, e) => {
		// 				if ('requestId' in e.raw && e.raw.requestId != null) {
		// 					mapGetOrCreate(acc, e.raw.requestId, () => new Set()).add(e);
		// 				}
		// 				return acc;
		// 			}, new Map<string, Set<DbRecordedEvent>>
		// 		).entries()].map( ([requestId, events]) => ([requestId, [...events].toSorted( (a,b) => a.eventIndex - b.eventIndex)] as const));
		// 	const script = JavaScript`const eventsByRequestId = new Map(${JSON.stringify(requestIdEventsPairs, undefined, "\t")});
		// 		document.addEventListener('DOMContentLoaded', () => {
		// 			console.log('DOMContentLoaded');
		// 			document.querySelectorAll('a[data-request-id]').forEach((element) => {
		// 				element.addEventListener('click', (e) => {
		// 					e.preventDefault();
		// 					const requestIdString = e.target.getAttribute('data-request-id');
		// 					const requestId = parseInt(requestIdString);
		// 					const event = eventsByRequestId.get(requestId);
		// 					navigator.clipboard.writeText("\`\`\`json\n" + JSON.stringify({id, ...event}, null, '\t') + "\n\`\`\`\n");
		// 				});
		// 			});
		// 		});
		// 	`;
	flushSync(() => {
		root.render(<>{recordingPanelState.primaryTabId !== 'Chronological' ? null : (<>
					<h1>{recordingPanelState.recordingNameOrDescription}</h1>
					<h2>{ReportName[recordingPanelState.primaryTabId]}</h2>
				</>)}
				<ReportDownloadRouterView {...{recordingPanelState}} />
		</>
		);
	});
	const reportHtml = html`<!DOCTYPE html>
<html lang="en" xml:lang="en" xmlns= "http://www.w3.org/1999/xhtml">
	<meta charset="UTF-8">
	<meta name="google" content="notranslate">
	<meta http-equiv="Content-Language" content="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${recordingPanelState.reportFullName}</title>
  </head>
  <body>
		${div.outerHTML}
  </body>
	</html>
	`
	downloadBlob(new Blob([reportHtml], {type: 'text/html'}), `${fileNameSafeString(recordingPanelState.reportFullName)}.html`);
};
